var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUseCaseRegistry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5938 25.9875H21.3125M24.4062 32.0375H21.3125M33.6875 19.9375H21.3125M39.875 19.635V35.365C39.875 37.9062 39.875 39.1769 39.3692 40.1475C38.9243 41.0013 38.2144 41.6954 37.3412 42.1304C36.3485 42.625 35.049 42.625 32.45 42.625H22.55C19.951 42.625 18.6515 42.625 17.6588 42.1304C16.7856 41.6954 16.0757 41.0013 15.6308 40.1475C15.125 39.1769 15.125 37.9062 15.125 35.365V19.635C15.125 17.0938 15.125 15.8231 15.6308 14.8525C16.0757 13.9987 16.7856 13.3046 17.6588 12.8696C18.6515 12.375 19.951 12.375 22.55 12.375H32.45C35.049 12.375 36.3485 12.375 37.3412 12.8696C38.2144 13.3046 38.9243 13.9987 39.3692 14.8525C39.875 15.8231 39.875 17.0938 39.875 19.635Z",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUseCaseRegistry);
export default __webpack_public_path__ + "static/media/use-case-registry.ef9465a809b2a4307f16c2b21479e8ea.svg";
export { ForwardRef as ReactComponent };